import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { WebEnvironmentService } from '@app/shared/services/web-environment.service';
import {
  OnboardingConfig,
  OnboardingConfigService,
} from '@app/onboarding/services/onboarding-config.service';
import { SubscriberBaseDirective } from '@app/shared/components/subscriber-base/subscriber-base.directive';
import { FooterButtonStates } from '@app/onboarding/components/onboarding-footer/onboarding-footer.model';
import { OnboardingStep } from '@app/onboarding/onboarding.enums';
import { Observable } from 'rxjs';
import { OnboardingStateService } from '@app/onboarding/services/onboarding-state.service';
import { AuthService } from '@app/shared/services/auth.service';

/**
 * Welcome Component
 * The first page the user sees when going thru the onboarding experience,
 *
 * There are 3 different onboarding configurations of the welcome screen
 * LXP
 * HMM(Harvard sparks)
 * DSA/DSI(same as LXP)
 *
 * <dgx-welcome></dgx-welcome>
 */

@Component({
  selector: 'dgx-welcome',
  templateUrl: './welcome.component.html',
  styleUrls: ['./welcome.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WelcomeComponent
  extends SubscriberBaseDirective
  implements OnInit
{
  public isLoading: boolean = true;
  public onboardingConfig: Observable<OnboardingConfig> =
    this.onboardingConfigService.config;
  public i18n = this.translateService.instant([
    'Onboarding_Step1Title',
    'Onboarding_Step1IdeasImgAlt',
    'Onboarding_ProgressInYourSkills',
    'Onboarding_ProgressInstructions',
    'Onboarding_Step1CategoriesImgAlt',
    'Onboarding_LearnFromAnySource',
    'Onboarding_LearnInstructions',
    'Onboarding_Step1IdeasImgAlt',
    'Onboarding_TrackYourSkills',
    'Onboarding_TrackYourSkillsInstructions',
    'Onboarding_WelcomeHeading',
    'Onboarding_WelcomeMountainIllustration',
    'OnboardingFooter_GetStarted',
  ]);

  constructor(
    private translateService: TranslateService,
    private webEnvironmentService: WebEnvironmentService,
    private onboardingConfigService: OnboardingConfigService,
    private onboardingStateService: OnboardingStateService
  ) {
    super();
  }

  public get onboarding_WelcomeDetails(): string {
    return this.translateService.instant(`Onboarding_WelcomeDetails`, {
      orgName: this.onboardingConfigService.organizationNameInOnboarding,
    });
  }
  public ngOnInit(): void {
    this.onboardingConfigService.footerButtonStateChange({
      currentStep: OnboardingStep.welcome,
      previousButton: '',
      nextButton: this.i18n.OnboardingFooter_GetStarted,
    } as FooterButtonStates);
    this.onboardingStateService.updateTrackerStep(null);
    this.onboardingStateService.currentStepChange(OnboardingStep.welcome);
  }

  public getBlobUrl(url) {
    return this.webEnvironmentService.getBlobUrl(url);
  }
}
